'use strict'

module.exports = function (ngModule) {
  ngModule
    .controller('ReferralCtrl', ["$scope", "$http", "$log", "$window", "$location", "Auth", "referralData", "$translate", "$uibModal", function ($scope, $http, $log, $window, $location, Auth, referralData, $translate, $uibModal) {
      // $scope.alerts = []
      $scope.alert = {
        type: '',
        message: '',
        data: ''
      }
      $scope.referral = {
        email: ''
      }
      $scope.messages = {
        hasHelpMessage: referralData.length > 0,
        helpMessages: referralData
      }
      //
      $scope.reset = function () {
        $scope.referral.email = ''
        $scope.alerts = []
      }
      //
      $scope.inputReferral = function (email) {
        return $http({
          method: 'GET',
          url: '/api/check_redeem_account',
          headers: Auth.getJwtHeader()
        }).then(function (userData) {
          $log.debug('check', userData)
          $location.path('/update_profile').search({ 'redirect': 'referral' })
        }).catch(function (err) {
          $log.debug(err)
          if (err.error && err.error.message) {
            $scope.alert = {
              type: 'failure',
              message: err.error.message
            }
          } else {
            $scope.alert = {
              type: 'failure',
              message: 'REDEEM_CODE_INVALID'
            }
          }
        })
      }
      $scope.openTerms = function () {
        $uibModal.open({
          templateUrl: 'template/partial/referral-terms-modal.html',
          controller: 'ModalInstanceCtrl',
          size: 'lg',
          resolve: {
            displayData: {}
          }
        })
      }
    }])
}



//////////////////
// WEBPACK FOOTER
// ./js/controllers/referral.js
// module id = 53
// module chunks = 0